/* v8 ignore start -- @preserve */

export enum LocalStorageKeys {
  OrganizationId = "organisationId",
  AppVersion = "appVersion",
  Config = "config",
  PrevPath = "prevPath",
  RefreshToken = "refreshToken",
  Registration = "registration",
  Token = "token",
  User = "user",
  UserId = "userId",
  OauthProvider = "oauthProvider",
  TxId = "txId",
  LpAuthLoginTaskCompleted = "lpAuthLoginTaskCompleted",
  TasksState = "tasksState",
}
